import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DeliveryNoteSSCCService = {

  async getDeliveryNoteSSCCRecords(deliveryNoteCode) {
    const requestScreenData = {
      url: "api/DeliveryNoteSSCC/Grouped/"+deliveryNoteCode,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async generateSSCC(deliveryNoteCode) {
    var url = `api/Save_DeliveryNoteSSCC`;
    var payload = { Code: deliveryNoteCode };
    return await ApiService.post(url, payload);
  },

  async printDeliveryNoteSSCC(payload) {
    var url = `api/Save_DeliveryNotePrintSSCC`;
    return await ApiService.post(url, payload);
  },

};

export { DeliveryNoteSSCCService };
